import React from 'react';
import Layout from '@app/layouts/_layout';
import Services from '@app/components/services';
import { ApiResponse, ItemDto, ServiceAttributes } from '@app/models/dtos/strapi';
import RadialGradient from '@app/components/ui/radial-gradient';
import { ILayoutProps } from '@app/models/props/home';

export interface IOurServicesProps extends ILayoutProps {
    services: Array<ApiResponse<ServiceAttributes>>;
    servicePage: ApiResponse<ItemDto>;
}

function OurServices({ settings, services, servicePage, locations, products, socialMedias }: IOurServicesProps) {
    return (
        <Layout settings={settings} socialMedias={socialMedias} locations={locations} products={products}>
            <RadialGradient />
            <Services services={services} servicePage={servicePage} />
        </Layout>
    );
}

export { getServerSideServicesProps as getServerSideProps } from '@app/lib/serverSideProps';
export default OurServices;
